<template>
  <div
    v-if="displayDropdown"
    class="background-freezer"
    tabindex="-1"
    @click="onClickBackgroundFreezer"
  >
    <div class="dropdown-search-menu">
      <dropdown-filters
        css-prefix="dropdown"
        @change="onFilterChange"
      />

      <div v-if="zeroResultsFound">
        <p class="dropdown-search-results ">
          No Results Found For
          {{ queryString }}
        </p>
      </div>
      <ul v-else class="dropdown-search-results">
        <search-result
          v-for="(searchResult, index) in searchResults"
          :key="searchResult.name"
          :search-result="searchResult"
          css-prefix="dropdown"
          :has-cursor="cursorIndex === index"
          image-size="50px"
          @mouseover.native="$emit('hover-over', index)"
        />
      </ul>
      <dropdown-footer
        :query-string="queryString"
      />
    </div>
  </div>
</template>

<script>
  import DropdownFilters from '../search-form/filters';
  import SearchResult from '../search-form/search-result';
  import DropdownFooter from './footer'

  export default {
    components: {
      DropdownFilters,
      SearchResult,
      DropdownFooter
    },
    props: {
      searchResults: { type: Array, required: true },
      queryString: { type: String, required: true },
      zeroResultsFound: { type: Boolean, required: true },
      cursorIndex: { type: Number, required: true }
    },
    computed: {
      displayDropdown() {
        return this.searchResults.length > 0 || this.zeroResultsFound;
      }
    },
    methods: {
      onClickBackgroundFreezer(event) {
        if (event.target.className.match(/background-freezer/)) {
          this.$emit('click-away')
        }
      },
      onFilterChange(filterValue) {
        this.$emit('filter-change', filterValue)
      }
    }
  };
</script>
